<template>
  <div class="character-template-detail">
    <!-- Tab Navigation -->
    <div class="gm-tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        :class="['gm-tab', { 'is-active': currentTab === index }]"
        @click="goToTab(index)"
      >
        <span class="tab-label">{{ tab.label }}</span>
      </div>
    </div>

    <!-- Tab Content -->
    <div class="tab-content gm-scroll">
      <component
        :is="tabs[currentTab].component"
        v-if="tabs[currentTab] && tabs[currentTab].component"
        v-bind="tabs[currentTab].data"
        @update="onTemplateUpdate"
      />
    </div>
  </div>
</template>

<script>
import BasicInfoTab from './tabs/BasicInfoTab.vue';
import StatsTab from './tabs/StatsTab.vue';
import BioTab from './tabs/BioTab.vue';
import EquipmentTab from './tabs/EquipmentTab.vue';
import AbilitiesTab from './tabs/AbilitiesTab.vue';

export default {
  name: 'CharacterTemplateDetail',
  components: {
    BasicInfoTab,
    StatsTab,
    BioTab,
    EquipmentTab,
    AbilitiesTab
  },
  props: {
    template: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentTab: 0
    };
  },
  computed: {
    tabs() {
      return [
        {
          label: "Basic Info",
          component: BasicInfoTab,
          data: {
            template: this.template,
            service: this.service
          }
        },
        {
          label: "Stats",
          component: StatsTab,
          data: {
            template: this.template,
            service: this.service
          }
        },
        {
          label: "Bio",
          component: BioTab,
          data: {
            template: this.template,
            service: this.service
          }
        },
        {
          label: "Equipment",
          component: EquipmentTab,
          data: {
            template: this.template,
            service: this.service
          }
        },
        {
          label: "Abilities",
          component: AbilitiesTab,
          data: {
            template: this.template,
            service: this.service
          }
        }
      ];
    }
  },
  methods: {
    goToTab(index) {
      if (index >= 0 && index < this.tabs.length) {
        this.currentTab = index;
      }
    },
    onTemplateUpdate(data) {
      this.$emit('update', data);
    }
  }
};
</script>

<style scoped>
.character-template-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--gm-surface-1);
  color: var(--gm-text);
}

.tab-content {
  flex: 1;
  padding: var(--gm-gap) var(--gm-gap-lg);
}
</style>